import { render, staticRenderFns } from "./MemberCreate.vue?vue&type=template&id=64ce6ba5&"
import script from "./MemberCreate.vue?vue&type=script&lang=js&"
export * from "./MemberCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports